import React, { useState } from 'react';
import { FolderPlus, Save } from 'lucide-react';
import { projectsAPI } from '../../services/api';
import '../admin/AdminSections.css';

const CreateProject = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    project_code: '',
    client_name: '',
    title: '',
    description: '',
    address: '',
    systems: '',
    color: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await projectsAPI.create(formData);
      setSuccess('Το έργο δημιουργήθηκε επιτυχώς!');
      setFormData({
        project_code: '',
        client_name: '',
        title: '',
        description: '',
        address: '',
        systems: '',
        color: ''
      });
      setTimeout(() => {
        if (onSuccess) onSuccess();
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Σφάλμα κατά τη δημιουργία του έργου');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-section" data-testid="create-project-section">
      <div className="section-header">
        <h2>
          <FolderPlus size={24} />
          Δημιουργία Νέου Έργου
        </h2>
      </div>

      <form onSubmit={handleSubmit} style={{ maxWidth: 700 }}>
        <div className="form-group-admin">
          <label>Κωδικός Έργου *</label>
          <input
            type="text"
            name="project_code"
            value={formData.project_code}
            onChange={handleChange}
            placeholder="π.χ. ERG-2024-001"
            required
            data-testid="project-code-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Όνομα Πελάτη *</label>
          <input
            type="text"
            name="client_name"
            value={formData.client_name}
            onChange={handleChange}
            placeholder="Ονοματεπώνυμο πελάτη"
            required
            data-testid="client-name-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Τίτλος Έργου *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Τίτλος έργου"
            required
            data-testid="project-title-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Περιγραφή</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Περιγραφή έργου"
            rows={3}
            data-testid="project-description-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Διεύθυνση</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Διεύθυνση έργου"
            data-testid="project-address-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Συστήματα</label>
          <input
            type="text"
            name="systems"
            value={formData.systems}
            onChange={handleChange}
            placeholder="Συστήματα αλουμινίου"
            data-testid="project-systems-input"
          />
        </div>

        <div className="form-group-admin">
          <label>Χρώμα</label>
          <input
            type="text"
            name="color"
            value={formData.color}
            onChange={handleChange}
            placeholder="Χρώμα"
            data-testid="project-color-input"
          />
        </div>

        {error && (
          <div style={{ color: '#d32f2f', background: '#ffebee', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.9rem' }} data-testid="create-project-error">
            {error}
          </div>
        )}

        {success && (
          <div style={{ color: '#2e7d32', background: '#e8f5e9', padding: '0.75rem 1rem', marginBottom: '1rem', fontSize: '0.9rem' }} data-testid="create-project-success">
            {success}
          </div>
        )}

        <button type="submit" className="btn-primary" disabled={loading} data-testid="create-project-submit">
          <Save size={18} />
          {loading ? 'Δημιουργία...' : 'Δημιουργία Έργου'}
        </button>
      </form>
    </div>
  );
};

export default CreateProject;
